import { formatDate } from './formatDate';

// eslint-disable-next-line import/prefer-default-export
export const formatDisclosureWithDate = (apyCdsString: string) => {
  return apyCdsString?.replace('%today%', formatDate(new Date()));
};
